import React from 'react';
import { useTranslation } from 'react-i18next';
import { QSpinner, QText } from '@qualio/ui-components';

import { useQualityUsers } from '../../hooks/useQualityUsers';
import { UNASSIGNED_OWNER } from './TemplateOwnerFilter';

export const ActiveOwnerFilter: React.FC<{ value: unknown }> = ({ value }) => {
  const { t } = useTranslation();
  const { data: users, isLoading } = useQualityUsers();

  if (value === UNASSIGNED_OWNER) return <QText>{t('template.list.filters.owner.unassigned')}</QText>;

  const owner = users?.find((user) => String(user.user_id) === value);
  if (owner) return <QText>{owner.full_name}</QText>;
  return isLoading ? <QSpinner size="sm" /> : <QText>-</QText>;
};
